import { useEffect } from 'react';
import { observer } from 'mobx-react';
import Loader from 'components/common/loader';
import useStores from 'hooks/use-stores.hooks';

const LogoutPage: React.FC = () => {
  const {
    authStore: { logout }
  } = useStores();

  useEffect(() => {
    logout();
  }, [logout]);

  return <Loader />;
};

export default observer(LogoutPage);
